export default "__VITE_ASSET__NXy4vf1T__"